<template>
  <IconBase
    view-box="0 0 32 32"
    :width="iconSize"
    :height="iconSize"
    icon-color="transparent"
  >
    <component
      v-if="category"
      :is="'IconItemCategory' + category"
      :icon-color="internalIconColor"
    />
  </IconBase>
</template>

<script lang="ts">
import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconItemCategoryAppliances from "@/common/components/icons/IconItemCategoryAppliances.vue";
import IconItemCategoryKitchen from "@/common/components/icons/IconItemCategoryKitchen.vue";
import IconItemCategoryFurniture from "@/common/components/icons/IconItemCategoryFurniture.vue";
import IconItemCategoryPc from "@/common/components/icons/IconItemCategoryPc.vue";
import IconItemCategoryDaily from "@/common/components/icons/IconItemCategoryDaily.vue";
import IconItemCategoryHobby from "@/common/components/icons/IconItemCategoryHobby.vue";
import IconItemCategoryFood from "@/common/components/icons/IconItemCategoryFood.vue";
import IconItemCategoryFashion from "@/common/components/icons/IconItemCategoryFashion.vue";
import IconItemCategoryOutdoor from "@/common/components/icons/IconItemCategoryOutdoor.vue";
import IconItemCategoryBeauty from "@/common/components/icons/IconItemCategoryBeauty.vue";
import IconItemCategoryGift from "@/common/components/icons/IconItemCategoryGift.vue";
import IconItemCategoryGiftCard from "@/common/components/icons/IconItemCategoryGiftCard.vue";
import IconItemCategoryTravel from "@/common/components/icons/IconItemCategoryTravel.vue";
import IconItemCategoryRestaurant from "@/common/components/icons/IconItemCategoryRestaurant.vue";
import IconItemCategoryBook from "@/common/components/icons/IconItemCategoryBook.vue";
import IconItemCategoryStudy from "@/common/components/icons/IconItemCategoryStudy.vue";
import IconItemCategoryDonation from "@/common/components/icons/IconItemCategoryDonation.vue";
import IconItemCategoryTicket from "@/common/components/icons/IconItemCategoryTicket.vue";
import { Options, Vue } from 'vue-class-component';
import commons from "@/common/store/modules/commons";

@Options({
  props: {
	id: { type: String, required: true },
	iconColor: { type: String, required: false, default: "customColor" },
	iconSize: { type: Number, default: 32 }
  },
  components: {
    IconBase,
    IconItemCategoryAppliances,
    IconItemCategoryKitchen,
    IconItemCategoryFurniture,
    IconItemCategoryPc,
    IconItemCategoryDaily,
    IconItemCategoryHobby,
    IconItemCategoryFood,
    IconItemCategoryFashion,
    IconItemCategoryOutdoor,
    IconItemCategoryBeauty,
    IconItemCategoryGift,
    IconItemCategoryGiftCard,
    IconItemCategoryTravel,
    IconItemCategoryRestaurant,
    IconItemCategoryBook,
    IconItemCategoryStudy,
    IconItemCategoryDonation,
    IconItemCategoryTicket
  }
})
export default class IconItemCategory extends Vue {
  id!: string;
  iconColor!: string;
  iconSize!: number;
  colorCode = commons.colorCode;

  get internalIconColor() {
    const iconColor = this.iconColor;
    const colorCode = commons.OrgPageSpecific?.page_color;
    return iconColor === "customColor" ? colorCode : iconColor;
  }
  get category() {
    switch (this.id) {
      case "item-category0":
        return "Appliances";
      case "item-category1":
        return "Kitchen";
      case "item-category2":
        return "Furniture";
      case "item-category3":
        return "Pc";
      case "item-category4":
        return "Daily";
      case "item-category5":
        return "Hobby";
      case "item-category6":
        return "Food";
      case "item-category7":
        return "Fashion";
      case "item-category8":
        return "Outdoor";
      case "item-category9":
        return "Beauty";
      case "item-category10":
        return "Gift";
      case "item-category11":
        return "GiftCard";
      case "item-category12":
        return "Travel";
      case "item-category13":
        return "Restaurant";
      case "item-category14":
        return "Book";
      case "item-category15":
        return "Study";
      case "item-category16":
        return "Donation";
      case "item-category17":
        return "Ticket";
      default:
        return "";
    }
  }
}
</script>
